import { configure } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { AsyncTrunk, ignore } from 'mobx-sync';
import { SyncStorage } from 'mobx-sync/src/sync';
import { createContext, useContext } from 'react';
import { isBrowser } from 'utils/domUtils';

import ActivityStore from './ActivityStore';
import AssetStore from './AssetStore';
import ContentClientStore, { ContentClientStoreInstance } from './ContentClientStore';
import InvestmentStore from './InvestmentStore';
import ManagementStore from './ManagementStore';
import MarketplaceStore from './MarketplaceStore';
import NotificationStore from './NotificationStore';
import OfferingStore from './OfferingStore';
import ProfileStore, { ProfileStoreInstance } from './ProfileStore';
import SearchStore from './SearchStore';
import UIStore from './UIStore';

export interface IStore {
  MarketplaceStore: MarketplaceStore;
  SearchStore: SearchStore;
  OfferingStore: OfferingStore;
  ContentClientStore: ContentClientStore;
  AssetStore: AssetStore;
  UIStore: UIStore;
  InvestmentStore: InvestmentStore;
  ManagementStore: ManagementStore;
  ProfileStore: ProfileStore;
  ActivityStore: ActivityStore;
  NotificationStore: NotificationStore;
  cookie?: {
    value?: string;
  };
  storeLoaded?: boolean;
}

export class Store implements IStore {
  @ignore
  storeLoaded = false;

  @ignore
  ProfileStore = ProfileStoreInstance;

  @ignore
  OfferingStore = new OfferingStore();

  @ignore
  AssetStore = new AssetStore();

  @ignore
  UIStore = new UIStore();

  @ignore
  SearchStore = new SearchStore();

  @ignore
  MarketplaceStore = new MarketplaceStore();

  @ignore
  ContentClientStore = ContentClientStoreInstance;

  @ignore
  InvestmentStore = new InvestmentStore();

  @ignore
  ManagementStore = new ManagementStore();

  @ignore
  NotificationStore = new NotificationStore();

  ActivityStore = new ActivityStore(this.MarketplaceStore, this.ContentClientStore);
}

export const store: IStore = new Store();
export const StoreContext = createContext(store);

export const useStore = () => {
  enableStaticRendering(!isBrowser());

  return useContext(StoreContext);
};

const trunk = new AsyncTrunk(store, {
  storage: (isBrowser() && window.localStorage) as SyncStorage,
  storageKey: '__stores__',
  delay: 1e3
});

trunk.init().then(() => {
  store.storeLoaded = true;
});

configure({ isolateGlobalState: true });
